import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="container">
        <p>&copy; {new Date().getFullYear()} IntelPro. All rights reserved.</p>
        <div className="footer-links">
          <Link to="/terms">Terms</Link>
          <Link to="/privacy-policy">Privacy</Link>
          <Link to="/contact">Contact Us</Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;